const map = {
	"./1.svg": "./src/assets/images/dashboard-3/course/1.svg",
	"./2.svg": "./src/assets/images/dashboard-3/course/2.svg",
	"./3.svg": "./src/assets/images/dashboard-3/course/3.svg",
	"./4.svg": "./src/assets/images/dashboard-3/course/4.svg"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/dashboard-3/course sync recursive ^\\.\\/.*\\.svg$";